import React, {useEffect, useState} from 'react';
import cn from 'classnames';
import {Swiper as SwiperType} from 'swiper/types';

import {ICarouselPaginationNumbersProps} from './ICarouselPaginationNumbers';

import styles from './CarouselPaginationNumbers.module.scss';

const CarouselPaginationNumbers = ({swiperRef, slidesCount, plainNumeration}: ICarouselPaginationNumbersProps) => {
	const [activeSlide, setActiveSlide] = useState(1);

	useEffect(() => {
		const swiperInstance = swiperRef.current;

		if (!swiperInstance) {
			return undefined;
		}

		const onTransitionEnd = (swiper: SwiperType) => {
			let activeIndex = swiper.realIndex + 1;

			while (activeIndex > slidesCount) {
				activeIndex -= slidesCount;
			}

			setActiveSlide(activeIndex);
		};

		swiperInstance.on('transitionEnd', onTransitionEnd);

		// One listener: the effect runs again when a page kept alive (`<Activity>`) is shown again.
		return () => {
			swiperInstance.off('transitionEnd', onTransitionEnd);
		};
	}, [swiperRef, slidesCount]);

	return (
		<div className={cn(styles['pagination-numbers'], 'pagination-numbers')}>
			<span>{`${!plainNumeration ? 0 : ''}${activeSlide}`.slice(-2)}</span>
			<span>{`${!plainNumeration ? 0 : ''}${slidesCount}`.slice(-2)}</span>
		</div>
	);
};

export default CarouselPaginationNumbers;
